import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './AccessGate.css';

const AccessGate = ({ correctCode, onAccessGranted }) => {
  const [inputCode, setInputCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const checkCode = () => {
    if (inputCode === correctCode) {
      if (onAccessGranted) onAccessGranted();
      navigate("/home");
    } else {
      setError("Incorrect code. Please try again.");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      checkCode();
    }
  };

  return (
    <div className="access-gate">
      <div className="access-gate-background">
        <div className="access-gate-pattern"></div>
      </div>
      
      <div className="access-gate-main">
        <div className="access-gate-content">
          <div className="access-gate-text">
            <h1>Andriana Skaperdas</h1>
            <p className="tagline">Digital Product Strategist</p>
            <h2>Bringing clarity to complex challenges</h2>
          </div>
          
          <div className="access-gate-visual">
            <div className="profile-photo-container">
              <div className="profile-photo">
                <img src={require('./assets/Headshot.png')} alt="Andriana Skaperdas - Digital Product Strategist" className="headshot-image" />
              </div>
            </div>
            <div className="resume-download-container">
              <a href="#contact" className="btn btn-primary">Download my resume</a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Access Form Bar */}
      <div className="access-form-bottom">
        <div className="access-form-content">
          <div className="access-form-inputs-horizontal">
            <div className="access-form-message">
              <span>Enter access code to learn more!</span>
            </div>
            <input
              type="password"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter code"
              className="access-input"
            />
            <button onClick={checkCode} className="access-submit">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1L15 8L8 15M15 8H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          {error && <div className="access-error">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default AccessGate; 